import { render, staticRenderFns } from "./TopSlider3.vue?vue&type=template&id=cf8b7384&"
import script from "./TopSlider3.vue?vue&type=script&lang=js&"
export * from "./TopSlider3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports